var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"draw-content"},[_c('div',{staticClass:"qr-code"},[_c('qrcode-vue',{attrs:{"value":_vm.qrcodeSrc,"size":250,"level":"M"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }